import { render } from "./ChannelVendorSelection.vue?vue&type=template&id=9cbbaaa2&scoped=true"
import script from "./ChannelVendorSelection.vue?vue&type=script&lang=js"
export * from "./ChannelVendorSelection.vue?vue&type=script&lang=js"

import "./ChannelVendorSelection.vue?vue&type=style&index=0&id=9cbbaaa2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cbbaaa2"]])

export default __exports__